"use client";

import React from "react";
import Image from "next/image";
import Navbar from "@/components/layout/navbar/Navbar";
import Breadcrumb from "@/components/Common/Breadcrumb";
import Button from "@/components/ui/Button";

const HeroSection: React.FC = () => {
    const scrollToForm = () => {
        const form = document.getElementById('application-form');
        form?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section className="relative w-full sm:min-h-88 bg-[#1B365E] flex flex-col items-center justify-start">
            <div className="absolute inset-0 z-0">
                <Image
                    src="/assets/enseigner-hero-bg.svg"
                    alt="Hero Background"
                    fill
                    priority
                    className="object-cover w-full h-full"
                />
                <div className="absolute inset-0 bg-[#1B365E]/55 sm:hidden" aria-hidden="true" />
            </div>

            <div className="relative z-100 w-full">
                <Navbar />
            </div>

            <div className="relative z-10 px-4 xl:px-10 pt-12.5 sm:pt-22 mb-11 sm:mb-6.5 w-full mx-auto">
                <Breadcrumb />
                <h1 className="font-red-hat font-normal text-[30px] sm:text-[48px] md:text-[60px] text-white leading-[37px] sm:leading-12.5 md:leading-19.75 tracking-[0.2px] mb-5.5 mx-auto">
                    Devenez Formateur <br /> avec Spot Formations
                </h1>
                <Button
                    variant="gradient"
                    className="text-[18px] leading-6.5 mt-4 sm:mt-0 sm:w-fit w-full"
                    onClick={scrollToForm}
                >
                    Nous rejoindre
                </Button>
            </div>

            <div className="flex items-center bg-white rounded-[40px] border-b border-[#40BFDE] py-3 px-4 justify-center absolute left-1/2 -translate-x-1/2 -bottom-5">
                <Image src='/assets/small-logo.svg' alt='small-logo' title='small-logo' width={30} height={17} />
            </div>

        </section>
    );
};

export default HeroSection;
